





































































































//import ExcelJS from 'exceljs';

import DecimalInput from "~/components/DecimaInput.vue";
import Swal from "sweetalert2";
import { Leitura, leitura_repository, TipoLeitura } from "~/store/leituras";

type DataType = {
  loading: boolean;
  alterando: boolean;
  errors: string[];
  leituras: Leitura[];
  leituras_originais: Leitura[];
};

export default {
  components: {
    DecimalInput,
  },
  data(): DataType {
    return {
      loading: true,
      alterando: false,
      errors: [],
      leituras: [],
      leituras_originais: [],
    };
  },
  filters: {
    number_format(value: number) {
      return this.number_format(value);
    },
  },
  methods: {
    number_format(value: number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      }).format(value);
    },
    async exportToExcel() {
      try {
        const Workbook = await import("exceljs").then(e => e.Workbook);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(
          this.tipo === "A" ? "Água" : "Gás"
        );

        const headerRow = worksheet.addRow([
          "Unidade",
          "Leitura Anterior",
          "Consumo",
          "Leitura Atual",
        ]);

        headerRow.font = { bold: true };

        this.leituras.forEach(leitura => {
          worksheet.addRow([
            leitura.descricao_unidade,
            leitura.leitura_anterior,
            leitura.consumo,
            leitura.leitura_atual,
          ]);
        });

        worksheet.columns.forEach(column => {
          column.width = 15;
        });

        const blob = await workbook.xlsx.writeBuffer();

        const nomeMes = new Date(
          Number(this.$route.query.ano),
          Number(this.$route.query.mes) - 1,
          1
        ).toLocaleString("default", { month: "long" });
        const nomeMesCapitalizado =
          nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1).toLowerCase();

        const fileName = `Leituras_${
          this.tipo === "A" ? "Água" : "Gás"
        }_${nomeMesCapitalizado}_${this.$route.query.ano}_((${
          this.condominio.abrev
        }) - ${this.condominio.nome}).xlsx`;

        const blobUrl = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName; // Use the adjusted file name
        link.click();

        // Clean up the Blob URL
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Error exporting to Excel:", error);
      }
    },
    async confirmar() {
      try {
        let leituras = this.leituras_alteradas;
        if (leituras.length == 0) {
          return Swal.fire({
            icon: "error",
            title: "Oops",
            text: "Nenhuma leitura alterada",
          });
        }
        this.alterando = true;
        this.errors = [];
        let originais = this.leituras_originais;
        let notificar: Leitura[] = [];
        for (let leitura of leituras) {
          try {
            let record = await leitura_repository.add({
              codigo_condominio: Number(this.condominio.codigo),
              record: {
                data: this.data,
                mes: Number(this.mes),
                ano: Number(this.ano),
                tipo: this.tipo,
                codigo_condominio: Number(this.condominio.codigo),
                codigo_unidade: leitura.codigo_unidade,
                descricao_unidade: leitura.descricao_unidade,
                leitura_atual: leitura.leitura_atual,
                leitura_anterior: leitura.leitura_anterior,
              },
            });

            notificar.push(record);

            let original = originais.find(({ id }) => id === record.id);
            if (original) {
              original.leitura_atual = leitura.leitura_atual;
            }
          } catch (err) {
            this.errors = [...this.errors, leitura.id || ""];
          }
        }

        if (notificar.length != 0) {
          await leitura_repository.sendNotification({
            records: notificar,
            mes: Number(this.mes),
            ano: Number(this.ano),
            tipo: this.tipo,
            codigo_condominio: Number(this.condominio.codigo),
          });
        }

        this.leituras_originais = originais;
        if (this.errors.length != 0) {
          Swal.fire({
            icon: "error",
            title: "Oops",
            text: "Alguns valores não puderam ser atualizados.",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Sucesso!",
            text: "Leituras lançadas com sucesso.",
          });
        }
        await this.loadData();
      } catch (err) {
        console.error(err);
      }
      this.alterando = false;
    },
    async loadLeituras() {
      try {
        if (!this.condominio) {
          return;
        }
        let codigo_condominio = this.condominio.codigo;
        let leituras = await leitura_repository.list({
          codigo_condominio: Number(codigo_condominio),
          tipo: this.tipo,
          ano: Number(this.ano),
          mes: Number(this.mes),
        });
        this.leituras = leituras;
        this.leituras_originais = JSON.parse(JSON.stringify(leituras));
      } catch (err) {
        console.error(err);
      }
    },
    async loadData() {
      this.loading = true;
      this.errors = [];
      this.leituras = [];
      this.leituras_originais = [];
      //this.alteradas = [];

      await this.loadLeituras();

      this.loading = false;
    },
  },
  computed: {
    leituras_alteradas() {
      let leituras = this.leituras.filter(leitura => {
        let original = this.leituras_originais.find(o => o.id == leitura.id);
        if (!original) {
          return true;
        }
        return leitura.leitura_atual != original.leitura_atual;
      });
      return leituras;
    },
    condominio() {
      return this.$store.getters.condominio;
    },
    operacao() {
      return this.$route.query.operacao;
    },
    mes() {
      return Number(this.$route.query.mes);
    },
    ano() {
      return Number(this.$route.query.ano);
    },
    tipo(): TipoLeitura {
      return this.$route.query.tipo as TipoLeitura;
    },
    data(): string {
      return this.$route.query.data as string;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.loadData();
      },
    },
  },
  async beforeRouteLeave(to, form, next) {
    if (0 === this.leituras_alteradas.length) {
      return next();
    }
    const { isConfirmed } = await Swal.fire({
      icon: "question",
      title: "Deseja sair sem salvar?",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    });
    if (isConfirmed) {
      next();
    }
  },
  mounted() {
    window.onbeforeunload = () => {
      if (this.leituras_alteradas.length != 0) {
        return "Deseja sair sem salvar?";
      }
    };
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
};
